/**
 * Synthetic continuation messages are session-local UI glue ("Continuing…"
 * bubbles inserted while a staged-action resume waits to subscribe) — never
 * persisted, and dropped when a backend refetch is merged. Minting and
 * recognition must agree on this prefix, so both live here.
 */
export const SYNTH_CONTINUATION_PREFIX = 'synth-continuation-'

export function makeSynthContinuationId(conversationId: string): string {
  return `${SYNTH_CONTINUATION_PREFIX}${conversationId}-${Date.now()}`
}

export function isSynthContinuationId(id: string | null | undefined): boolean {
  return id?.startsWith(SYNTH_CONTINUATION_PREFIX) ?? false
}
